"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var SupplierAgreementWarningFlag_1 = require("../../supply/model/SupplierAgreementWarningFlag");

var SupplierAgreementTransferValidationDTO_1 = require("../model/SupplierAgreementTransferValidationDTO");

var SupplierAgreementTransferValidationDTOConverter_1 = require("./SupplierAgreementTransferValidationDTOConverter");
/**
 * Default implementation of SupplierAgreementTransferValidationDTO
 *
 * @author PKr
 */


var SupplierAgreementTransferValidationDTOConverterImpl =
/*#__PURE__*/
function (_SupplierAgreementTra) {
  _inherits(SupplierAgreementTransferValidationDTOConverterImpl, _SupplierAgreementTra);

  function SupplierAgreementTransferValidationDTOConverterImpl() {
    _classCallCheck(this, SupplierAgreementTransferValidationDTOConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementTransferValidationDTOConverterImpl).apply(this, arguments));
  }

  _createClass(SupplierAgreementTransferValidationDTOConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      return new SupplierAgreementTransferValidationDTO_1.SupplierAgreementTransferValidationDTO(SupplierAgreementTransferValidationDTO_1.SupplierAgreementTransferValidationDTO.schema.supplierAgreementId.valueOf(conversions.toClassReferenceId(source.supplierAgreementId)), SupplierAgreementTransferValidationDTO_1.SupplierAgreementTransferValidationDTO.schema.windowItemId.valueOf(conversions.toClassReferenceId(source.windowItemId)), SupplierAgreementTransferValidationDTO_1.SupplierAgreementTransferValidationDTO.schema.supplierId.valueOf(conversions.toClassReferenceId(source.supplierId)), conversions.asFlagSet(source.flags, SupplierAgreementWarningFlag_1.SupplierAgreementWarningFlag));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        supplierAgreementId: conversions.toDocumentReferenceId(source.supplierAgreementId),
        windowItemId: conversions.toDocumentReferenceId(source.windowItemId),
        supplierId: conversions.toDocumentReferenceId(source.supplierId),
        flags: source.flags.serialize()
      });
      return result;
    }
  }]);

  return SupplierAgreementTransferValidationDTOConverterImpl;
}(SupplierAgreementTransferValidationDTOConverter_1.SupplierAgreementTransferValidationDTOConverter);

exports.SupplierAgreementTransferValidationDTOConverterImpl = SupplierAgreementTransferValidationDTOConverterImpl;